import { required } from 'vuelidate/lib/validators';

const validations = {
  title: {
    required,
  },
  description: {
    required,
  },
  address: {
    required,
  },
  phone: {
    required,
  },
  defaultPrice: {
    required,
  },
  fax: {
    required,
  },
  countryId: {
    required,
  },
  townId: {
    required,
  },
  officeNumber: {
    required,
  },
};

export default validations;